import React, { useContext, useEffect, Fragment } from 'react';
import AuthContext from '../../../Context/autenticacion/authContext';
import SalesAdmin from './SalesAdmin';
import SalesSeller from './SalesSeller';
import AlertNotAuthorized from '../../../Complements/AlertNotAuthorized';

export default function SalesIndex() {
   //Extraer la informacion de autenticación
   const authContext = useContext(AuthContext);
   const { usuario, usuarioAutenticado } = authContext;

   useEffect(() => {
    usuarioAutenticado();
  }, []);

  let component;
  if(usuario){
    switch (usuario.type) {
		  case '1':
			component = <SalesAdmin />
			break;
		  case '2': 
			component = <SalesSeller />
      		break;
      	  case '3': 
			component = <SalesSeller />
			break;
		  default:
			component = <AlertNotAuthorized mensaje={"No tienes los suficientes permisos para ver esta página"}/>
			break;
    }
  }
  return (
    <Fragment>
      {component}
    </Fragment>
  )
}
